import Header from "./Components/Header/Header";
import reflowChartsBeforePrint from "./Helper/reflow";
import { useEffect, useState } from "react";
import Content from "./Components/Content/Content";
import { FlinkContext, getData } from "./context/FlinkContext";
import Highcharts from "highcharts";
import "bootstrap/dist/css/bootstrap.css";
import Footer from "./Components/Footer/Footer";

reflowChartsBeforePrint(Highcharts);

function App() {
  const [overview, setOverview] = useState(null);
  const [power, setPower] = useState(null);
  const [gas, setGas] = useState(null);
  const [forecasts, setForecasts] = useState(null);
  const [carbon, setCarbon] = useState(null);
  const [mix, setMix] = useState(null);
  const [oil, setOil] = useState(null);

  useEffect(() => {
    getData("GetOverview").then((result) => setOverview(result));
    getData("GetPower").then((result) => setPower(result));
    getData("GetGas").then((result) => setGas(result));
    getData("GetCarbon").then((result) => setCarbon(result));
    getData("GetGenMix").then((result) => setMix(result));
    getData("GetForecasts").then((result) => setForecasts(result));
    getData("GetOil").then((result) => setOil(result));
  }, []);

  reflowChartsBeforePrint(Highcharts);

  return (
    <div className="App">
      <Header />
      <FlinkContext.Provider
        value={{ overview, power, gas, forecasts, carbon, mix, oil }}
      >
        <Content />
      </FlinkContext.Provider>
      <Footer />
    </div>
  );
}

export default App;
